import { getElementDiv, prepareRender, renderRoadmap, addDisplayTile } from "@/modules/commonRoadmapSmall";
import { IRoadmapSmallClass } from "@/types/RoadmapSmallTypes";
import { headTailLefts } from "@/modules/commonMobile";

export default class M10 extends IRoadmapSmallClass {
	render() {
		prepareRender(this);

		//Obligatory counters
		let currentType = "";
		
		// Formats this.props.history to desired roadmap
		switch (this.props.filter) {
			case "head-tail":
				this.props.history.forEach((item, idx, ary) => {
					let ele = null;
					const angka = item.angka.split(",");
					let heads = 0, tails = 0;
					
					for (const a of angka) {
						if (Number(a) === 1)
							++heads;
						else ++tails;
					}
					
					if (heads > tails) {
						currentType = "head";
						ele = getElementDiv(this, ["circle", "red"], idx, ary);
					} else {
						currentType = "tail";
						// ele = <div className={"sl-roadmap-circle sl-blue " + (historyBlink && (idx === ary.length - 1) ? alternatingStyle : null)} />;
						ele = getElementDiv(this, ["circle", "blue"], idx, ary);
					}
					
					addDisplayTile(this.roadmapArray, ele, currentType, this);
				});
			break;
			case "left-right":
				this.props.history.forEach((item, idx, ary) => {
					let ele = null;
					const angka = item.angka;
					
					if (headTailLefts.indexOf(angka) >= 0) {
						currentType = "left";
						ele = getElementDiv(this, ["circle", "red"], idx, ary);
					} else {
						currentType = "right";
						ele = getElementDiv(this, ["circle", "black"], idx, ary);
					}
					
					addDisplayTile(this.roadmapArray, ele, currentType, this);
				});
			break;
			default: return null;
		}
		
		return renderRoadmap(this);
	}
}
